import React from "react";

import CommissionsContent from "../components/commissions/commissions-content";

const Commissions = () => {
  return <CommissionsContent />;
};

export default Commissions;
